import { Sun, Moon, Palette } from "lucide-react";
import { useTheme } from "@contexts/ThemeContext";

const order = ["dark", "midcentury", "highcontrast", "light", "earthen", "highcontrast-light"];
const labels = {
  dark: "Dark",
  midcentury: "Mid-Century",
  highcontrast: "High Contrast",
  light: "Light",
  earthen: "Earthen",
  "highcontrast-light": "HC Light",
};

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const cycle = () => {
    const i = order.indexOf(theme);
    const next = order[(i + 1) % order.length];
    setTheme(next);
  };

  const Icon = theme === "dark" ? Palette : theme === "midcentury" ? Sun : Moon;
  const nextLabel = labels[order[(order.indexOf(theme) + 1) % order.length]];

  return (
    <button
      onClick={cycle}
      className="p-2 rounded-lg transition-colors hover:bg-white/[0.05]"
      style={{
        background: 'var(--bg-input)',
        border: '1px solid var(--border-input)',
      }}
      title={`Switch to ${nextLabel} theme`}
      aria-label={`Switch to ${nextLabel} theme`}
    >
      <Icon className="w-4 h-4" style={{ color: 'var(--text-heading)' }} />
    </button>
  );
}
